// extracted by mini-css-extract-plugin
export default {"heading":"BrandHeader__heading--Ss0WK"};